import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "pages",
    loadChildren: () =>
      import("../../components/pages/pages.routes").then((r) => r.pages),
    data: {
      breadcrumb: "Pages",
    },
  },
];
